<template>

    <v-form class="ui-form" ref="formRef" v-slot="validationResult"
            @submit="onSubmitInternal" @invalid-submit="onInvalidSubmitInternal">

        <slot v-bind="validationResult"></slot>

        <input type="submit" ref="submitButtonRef" v-show="false" />

    </v-form>

</template>

<script lang="ts">

import { Component, Prop, Ref, Vue } from 'vue-facing-decorator';

import { Form as VForm, InvalidSubmissionHandler, SubmissionHandler } from 'vee-validate';

import type { ComponentProps } from '@wittignl/js-core';
import { createComponentMixin } from '@wittignl/js-core';

const vValidateFormMixin = {
    props: VForm.props
}

@Component({
    name: 'ui-form',
    components: {
        'v-form': VForm
    },
    mixins: [vValidateFormMixin],
    emits: ['submit', 'invalid-submit']
})
export default class Form extends Vue {

    @Prop({ type: Boolean })
    silent: boolean;

    @Ref
    formRef: any;

    @Ref
    submitButtonRef: HTMLInputElement;

    validate(options?) {

        return this.formRef.validate(options);
    }

    reset() {

        this.formRef.resetForm();
    }

    submit() {

        this.submitButtonRef.click();
    }

    onSubmitInternal(e) {

        this.$emit('submit', e);
    }

    onInvalidSubmitInternal(e) {

        if(!this.silent){
            this.$toast.validation();
        }

        this.$emit('invalid-submit', e);
    }
}

export type FormComp = InstanceType<typeof Form>
export type FormProps = ComponentProps<FormComp> & {
    onSubmit: SubmissionHandler<any, unknown>;
    as: string;
    initialValues: Record<string, any>;
    validateOnMount: boolean;
    validationSchema: Record<string, any>;
    initialErrors: Record<string, any>;
    initialTouched: Record<string, any>;
    onInvalidSubmit: InvalidSubmissionHandler<any>;
    keepValues: boolean;
}

export const formCompMixin = createComponentMixin(Form, vValidateFormMixin)

</script>
<style src="../../../scss/component/form/Form.scss" lang="scss"></style>